import { TooltipWrapper } from 'components/TooltipWrapper'
import React from 'react'
import styled from 'styled-components'

const FlexContainerTruncated = styled.div<{ $maxWidth?: string }>`
  display: flex;
  flex-direction: column;
  justify-items: flex-start;
  max-width: ${({ $maxWidth }) => $maxWidth || '25rem'};
  cursor: default;
  span {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`

const FlexContainer = styled.div<{ $maxWidth?: string }>`
  display: flex;
  flex-direction: column;
  justify-items: flex-start;
  max-width: ${({ $maxWidth }) => $maxWidth || '25rem'};
  cursor: default;
`

const Subtitle = styled.span`
  font-size: 0.6875rem;
  color: ${({ theme }) => theme.forecast.secondaryText};
`

const EmptyText = styled.span`
  color: ${({ theme }) => theme.forecast.tertiaryText};
`

export const TextCell: React.FC<{
  text?: string
  subtitle?: string
  emptyText?: string
  truncate?: boolean
  textColor?: string
  maxWidth?: string
}> = ({ text, subtitle, emptyText, truncate, textColor, maxWidth }) =>
  truncate ? (
    <TooltipWrapper side='top' label={text} offset={5}>
      <FlexContainerTruncated $maxWidth={maxWidth}>
        {text && text !== '' ? (
          <span>{text}</span>
        ) : emptyText ? (
          <EmptyText>{emptyText}</EmptyText>
        ) : (
          <EmptyText>–</EmptyText>
        )}
        {subtitle && <Subtitle>{subtitle}</Subtitle>}
      </FlexContainerTruncated>
    </TooltipWrapper>
  ) : (
    <FlexContainer $maxWidth={maxWidth}>
      {text && text !== '' ? (
        <span style={{ color: textColor }}>{text}</span>
      ) : emptyText ? (
        <EmptyText>{emptyText}</EmptyText>
      ) : (
        <EmptyText>–</EmptyText>
      )}
      {subtitle && <Subtitle>{subtitle}</Subtitle>}
    </FlexContainer>
  )
